import React from "react";
import styled from "styled-components";
import I10n from '../../features/i10n';
import PropTypes from 'prop-types';
import Button from "../../atoms/button";
import LoadingSpinner from "../../atoms/loading";
import { PRIMARY_COLOR } from "../../color-constants";

const TRIANGLE_HEIGHT = 8;
const BORDER_OFFSET = 2;

const Wrapper = styled.div`
  display: flex;
  position: relative;
`;

const Container = styled.div`
  position: relative;
  height: 40px;
  ${props => props.expand ? `width: 100%;` : ''}

  @media (min-width: 800px) {
    ${props => props.showDisclaimer && `
      z-index: 376;
  `}
  }
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: ${props => props.offsetHeight}px;
  left: 50%;
  ${props => props.forceLeft ? `transform: translateX(-100%) translateX(${TRIANGLE_HEIGHT}px) !important; ` : `transform: translateX(-50%) translateX(${-props.offsetWidth}px) !important;`}
  display: ${props => (props.visible ? "block" : "none")};
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  z-index: 20;
  ::before,
  ::after {
    position: absolute;
    ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT}px;` : `top: -${TRIANGLE_HEIGHT}px;`}

    ${props => props.forceLeft ? `left: calc(100% - ${TRIANGLE_HEIGHT}px);` : `left: calc(50% + ${props.offsetWidth}px);`}
    transform: translateX(-50%);
    width: 0;
    height: 0;
    content: "";
    border-left: ${TRIANGLE_HEIGHT}px solid transparent;
    border-right: ${TRIANGLE_HEIGHT}px solid transparent;
    ${props => props.triangleOrientation === 'bottom' ? `border-top: ${TRIANGLE_HEIGHT}px solid rgb(255, 255, 255);` : `border-bottom: ${TRIANGLE_HEIGHT}px solid rgb(255, 255, 255);`}

  }
  ::before {
    ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT + 2}px;` : `top: -${TRIANGLE_HEIGHT + 2}px;`}
    ${props => props.triangleOrientation === 'bottom' ? `border-top: 10px solid rgba(0, 0, 0, 0.15);` : `border-bottom: 10px solid rgba(0, 0, 0, 0.15);`}
  }

  @media all and (-ms-high-contrast: none) {
    position: absolute;
     top: ${props => props.offsetHeight}px;
     left: 50%;
     ${props => props.forceLeft ? `transform: translateX(-100%) translateX(${TRIANGLE_HEIGHT}px) !important; ` : `transform: translateX(-50%) translateX(${-props.offsetWidth}px) !important;`}
     display: ${props => (props.visible ? "block" : "none")};
     background-color: #ffffff;
     box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
     z-index: 20;
     border: 1px solid #cccccc;
     ::before,
     ::after {
       position: absolute;
       ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT}px;` : `top: -${TRIANGLE_HEIGHT}px;`}
       ${props => props.forceLeft ? `left: calc(100% - ${TRIANGLE_HEIGHT}px) !important;` : `left: calc(50% + ${props.offsetWidth}px) !important;`}
       transform: translateX(-50%);
       width: 0;
       height: 0;
       content: "";
       border-left: ${TRIANGLE_HEIGHT}px solid transparent;
       border-right: ${TRIANGLE_HEIGHT}px solid transparent;
       ${props => props.triangleOrientation === 'bottom' ? `border-top: ${TRIANGLE_HEIGHT}px solid rgb(255, 255, 255);` : `border-bottom: ${TRIANGLE_HEIGHT}px solid rgb(255, 255, 255);`}

     }
     ::before {
      ${props => props.triangleOrientation === 'bottom' ? `bottom: -${TRIANGLE_HEIGHT + 2}px;` : `top: -${TRIANGLE_HEIGHT + 2}px;`}
      ${props => props.triangleOrientation === 'bottom' ? `border-top: 10px solid rgba(0, 0, 0, 0.15);` : `border-bottom: 10px solid rgba(0, 0, 0, 0.15);`}
     }
 }

  @media (max-width: 800px) {
    display: none;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  width: 250px;
  box-sizing: border-box;
  text-align: center;
`;

const DisclaimerTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  margin-bottom: 20px;
`;

const DisclaimerBody = styled.span`
  font-weight: 400;
  font-size: 14px;
   margin-bottom: 20px;
  color: #626469;
`;

const DisclaimerWrapper = styled.div`
  position: fixed;
  z-index: 375;
  top: 0px;right: 0px;bottom:0px;left:0px;
  background-color: rgba(51,51,51, 0.5);
  @media (max-width: 800px) {
    display: none;
  }
`;

const SpinnerWrapper = styled.div`
  margin-left: 10px;
  display: flex;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  ${props => props.showDisclaimer ? 'pointer-events: none;' : ''}
`;

class CustomerCenterButton extends React.Component {

  static propTypes = {
    software: PropTypes.string,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    showDisclaimer: PropTypes.bool,
    onDisclaimerDismiss: PropTypes.func,
    expand: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      showDisclaimer: props.showDisclaimer,
      isTransformed: false,
      triangleOrientation: 'top',
      offsetHeight: 0,
      offsetWidth: 0,
      correctionWidthOffset: props.correctionWidthOffset || 0
    }
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate() {
    if (this.toggleElement && !this.state.isTransformed) {
      this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
    }
    if (
      this.containerElement &&
      !this.props.center &&
      !this.state.isTransformed
    ) {
      this.calculateOffsets();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(newState) {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };
  setToggleRef = element => {
    this.toggleElement = element;
  };
  setContainerRef = element => {
    this.containerElement = element;
  };

  setOffsetHeight = (offsetHeight, triangleOrientation) => {
    if (this.state.offsetHeight !== offsetHeight) {
      this.updateStateIfMounted({ offsetHeight, isTransformed: true, triangleOrientation });
    }
  };
  setOffsetWidth = (offsetWidth) => {
    if (this.state.offsetWidth !== offsetWidth) {
      this.updateStateIfMounted({ offsetWidth, isTransformed: true });
    }
  };

  calculateOffsets = () => {

    const { left, right, height } = this.containerElement.getBoundingClientRect();
    const { top: topToggle, bottom: bottomToggle } = this.toggleElement.getBoundingClientRect();
    const boundingElementRect = (this.props.boundingElement) ? this.props.boundingElement.getBoundingClientRect() :
      window.document.body.getBoundingClientRect();

    const {
      right: rightBound,
      left: leftBound,
      top: topBound,
      bottom: bottomBound,
    } = boundingElementRect;

    if (right > rightBound) {
      let offsetWidth = right - rightBound + BORDER_OFFSET - this.state.correctionWidthOffset;
      this.setOffsetWidth(offsetWidth);
    }
    else if (left < leftBound) {
      let offsetWidth = -Math.abs(leftBound - left - BORDER_OFFSET + this.state.correctionWidthOffset);
      this.setOffsetWidth(offsetWidth);
    }
    if (this.props.prioritizeTop) {
      if ((topToggle - height) < topBound) {
        this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
      } else if ((bottomToggle + height) > bottomBound) {
        this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
      }
    } else {
      if (this.props.allowTop) {

        if ((bottomToggle + height) > bottomBound) {
          this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
        } else {
          if ((topToggle - height) < topBound) {
            this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
          }
        }
      } else {
        this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
      }
    }
  };

  render = () => {
    return (
     <Wrapper ref={this.setWrapperRef}>
      <Container expand={this.props.expand} showDisclaimer={this.props.showDisclaimer} ref={this.setToggleRef}>
        <ButtonWrapper showDisclaimer={this.props.showDisclaimer} >
          <Button expand={this.props.expand} importance="emphasized" primary icon={this.props.icon} disabled={this.props.disabled} onClick={() => { this.props.onClick();  }}>
            {this.props.isLoading ? <SpinnerWrapper><LoadingSpinner width="10px" height="10px"></LoadingSpinner></SpinnerWrapper> :
              I10n.get('screen.licence_selector_save_screen.get_in_touch_with_sales')
            }
          </Button>
        </ButtonWrapper>
        <ContentWrapper visible={this.props.showDisclaimer} ref={this.setContainerRef} offsetHeight={this.state.offsetHeight} offsetWidth={this.state.offsetWidth} offsetWidthTriangle={this.state.offsetWidthTriangle} triangleOrientation={this.state.triangleOrientation}>
          {this.props.showDisclaimer && <Content>
            <DisclaimerTitle>{I10n.get('screen.licence_selector_save_screen.get_in_touch_with_sales')}</DisclaimerTitle>
            <DisclaimerBody>{I10n.get(`screen.licence_selector_save_screen.get_in_touch_with_sales.${this.props.software}.description`)}</DisclaimerBody>
            <Button importance="emphasized" primary onClick={() => { this.props.onDisclaimerDismiss(); }}>{I10n.get('screen.licence_selector_save_screen.contact_customer_center.i_understand')}</Button>
          </Content>}
        </ContentWrapper>
      </Container>
      {this.props.showDisclaimer && <DisclaimerWrapper></DisclaimerWrapper>}
    </Wrapper>
    );
  }
}

export default CustomerCenterButton;

